import { render, staticRenderFns } from "./NewsForm.vue?vue&type=template&id=8b2b340e&scoped=true"
import script from "./NewsForm.vue?vue&type=script&lang=js"
export * from "./NewsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2b340e",
  null
  
)

export default component.exports